export class BaseService {
    protected locale: string

    constructor(
        locale: string,
    ) {
        this.locale = locale.replaceAll("_", "-")
    }

    getLocale(): string {
        return this.locale
    }
}